(function () {
    'use strict';

    /**
     * @ngdoc service
     * @name adminCrewBatchers.factory:CrewBatchFactory
     *
     * @description
     *
     */
    angular
        .module('pairingCompliments')
        .factory('PairingComplimentsFactory', PairingComplimentsFactory);

    function PairingComplimentsFactory() {

        function SearchCriteriaDTO() {
        	this.modelNumber = null;
          this.airportList = null;
        	this.heavyFlight = "All";
        }

		function PairingComplimentsDTO(){
			this.configId = null;
		}

		function PairingComplimentsInfoDTO(){
		  this.configId = null;
		  this.updatedTime = null;
		  this.modelNumber = null;
		  this.heavyFlight = "N";
			this.airportList = [];
			this.version = -1;
			this.languages = [];
			this.crewReq = [];
		}

		function LanguageReqInfoDTO(){
		  this.langCompSeqId = null;
			this.langCode = null;
			this.languageDesc = null;
			this.noOfCrew = 0;
		}

		function DeletePairingCompliments(){
			this.configId = null;
			this.version = null;
		}


		function FormatPairingComplimentsList(pairingComplimentsList){
			var formattedList = [];
	        angular.forEach(pairingComplimentsList, function (pc) {
	        	var pairingCompliments = new PairingComplimentsDTO();
            pairingCompliments.configId = pc.configId;
	            formattedList.push(pairingCompliments);
	        });
	        return formattedList;
		}

		function PopulatePairingComplimentsSearchRequest(params){
			var searchRequest = new SearchCriteriaDTO();
      searchRequest.modelNumber = params.modelNumber != null ? params.modelNumber.airCraftType : null;
      var airportList = [];

      angular.forEach(params.airportList, function (ap) {
        airportList.push(ap.airPortCode);
      });

      searchRequest.airportList = params.airportList != null ? airportList : null;
			searchRequest.heavyFlight = params.heavyFlight;
      searchRequest.pageSize = params.pageSize;
      searchRequest.startPosition = params.startPosition;
			return searchRequest;
		}

		function FormatPairingComplimentsInfoSearchResponse(crewTypes, dataList) {
			var pairingComplimentsInfo = [];
			angular.forEach(dataList, function(pc) {
				var pairingCompliments = new PairingComplimentsInfoDTO();

        pairingCompliments.configId = pc.configId;
        // pairingCompliments.updatedTime = pc.updatedTime;
        pairingCompliments.modelNumber = pc.modelNumber;
        pairingCompliments.heavyFlight = pc.isHeavyFlight;
        pairingCompliments.airportList = pc.airPorts;
        pairingCompliments.languages = pc.configForLangCompliment;

        var orderedCrewReqTypes = [];
        angular.forEach(crewTypes, function (crewType) {
          angular.forEach(pc.configForCrewCompliment, function (reqCrewType) {
            if(reqCrewType.crewTypeCode == crewType.crewTypeCode){
              orderedCrewReqTypes.push(reqCrewType);
            }
          });

        });

        pairingCompliments.crewReq = orderedCrewReqTypes;

        pairingComplimentsInfo.push(pairingCompliments);
			});
			return pairingComplimentsInfo;
		}


		function FormatLanguagesSearchResponse(languagesList){
			var formated = [];
			angular.forEach(languagesList, function(lang) {
				var language = new LanguageReqInfoDTO();
				language.langCode = lang.languageCode;
				language.languageDesc = lang.languageDesc;
				language.langCompSeqId = lang.langCompSeqId
				formated.push(language);
			});
			return formated;
		}




		function GetNewPairingCompliments(){
			var pairingComplimentsInfo = new PairingComplimentsInfoDTO();
			return pairingComplimentsInfo;
		}

		function FormatGridSelectedRow(rowData, masterLists){

      var airportList = [];

      angular.forEach(rowData.airportList, function(airport) {
        angular.forEach(masterLists.airportList, function(masterAirport) {
          if(angular.equals(masterAirport.airPortCode,airport)){
            airportList.push(masterAirport)
          }

        });
      });

      var languages = [];
      angular.forEach(rowData.languages, function(language) {
        angular.forEach(masterLists.languages, function(masterLang) {
          if(angular.equals(masterLang.langCode,language.langCode)){
            masterLang.noOfCrew = language.requiredCrew;
            masterLang.langCompSeqId = language.langCompSeqId;
            languages.push(masterLang);
          }

        });
      });

      var crewTypeCode = [];

      angular.forEach(rowData.crewReq, function(crewTypeReq) {

        angular.forEach(masterLists.crewTypeCodes, function(masterCrewTypeReq) {
          if(angular.equals(masterCrewTypeReq.crewTypeCode,crewTypeReq.crewTypeCode)){
            masterCrewTypeReq.reqCrew = crewTypeReq.reqCrew;
            masterCrewTypeReq.crewCompSeqId = crewTypeReq.crewCompSeqId;
            crewTypeCode.push(masterCrewTypeReq);
          }

        });
      });

      var modelNumber = null;
      angular.forEach(masterLists.airCraftTypes, function (airCraftType) {
        if(angular.equals(airCraftType.airCraftType,rowData.modelNumber)){
          modelNumber = airCraftType;
        }

      });

      var pairingComplimentsInfo = new PairingComplimentsInfoDTO();

      pairingComplimentsInfo.configId = rowData.configId;
      pairingComplimentsInfo.modelNumber = modelNumber;
      pairingComplimentsInfo.heavyFlight = rowData.heavyFlight;
      pairingComplimentsInfo.airportList = airportList;
      pairingComplimentsInfo.languages = languages;
      pairingComplimentsInfo.crewReq = crewTypeCode;

      return pairingComplimentsInfo;
		}

		function PopulatePairingComplimentsDeleteRequest(params){
			var deleteRequest = new DeletePairingCompliments();
			deleteRequest.version = params.version;
			deleteRequest.configId = params.configId;
			return deleteRequest;
		}

		function PopulatePairingComplimentsSaveRequest(crewTypesReq,params){
      var SavePairingComplimentsRequest = new PairingComplimentsInfoDTO();

			SavePairingComplimentsRequest.configId = params.configId;

      SavePairingComplimentsRequest.heavyFlight = params.heavyFlight;
      SavePairingComplimentsRequest.modelNumber = params.modelNumber.airCraftType;

      var airportCodes = [];
      angular.forEach(params.airportList, function(airport) {
        airportCodes.push(airport.airPortCode);
      });


      SavePairingComplimentsRequest.airportList = airportCodes;
      SavePairingComplimentsRequest.languages = params.languages;
      SavePairingComplimentsRequest.crewReq = crewTypesReq;

			return SavePairingComplimentsRequest;
		}

		function setLanguageRequermentIdAndVersion(langReqArray,initialLangReqArray){

			angular.forEach(langReqArray, function(langReqNew) {
				angular.forEach(initialLangReqArray, function(langReqOld) {
					if(langReqOld.language != null && langReqNew.languageCode === langReqOld.language.languageCode){
						langReqNew.languageReqId = langReqOld.languageReqId;
						langReqNew.version = langReqOld.version;
					}
				});

			});

			return langReqArray;

		}

        return {
        	formatPairingComplimentsList : FormatPairingComplimentsList,
        	populatePairingComplimentsSearchRequest : PopulatePairingComplimentsSearchRequest,
        	formatPairingComplimentsInfoSearchResponse : FormatPairingComplimentsInfoSearchResponse,
        	formatLanguagesSearchResponse : FormatLanguagesSearchResponse,
        	getNewPairingCompliments : GetNewPairingCompliments,
        	formatGridSelectedRow : FormatGridSelectedRow,
        	populatePairingComplimentsDeleteRequest : PopulatePairingComplimentsDeleteRequest,
        	populatePairingComplimentsSaveRequest : PopulatePairingComplimentsSaveRequest
        }
    }
})();
